<template>
  <div v-if="open" class="scd" @click.self="emit('close')">
    <div class="scd__panel" role="dialog" aria-modal="true" aria-label="계약서 삭제">
      <header class="scd__head">
        <h2 class="scd__title">계약서 삭제</h2>
        <button type="button" class="scd__x" aria-label="삭제 창 닫기" @click="emit('close')">
          <AppIcon icon="mdi-close" :size="20" />
        </button>
      </header>
      <form class="scd__body" @submit.prevent="onSubmit">
        <p class="scd__lead">
          <strong>{{ orgName || '기관명 없음' }}</strong> 계약서를 삭제합니다.
          비밀번호를 다시 입력해 주세요.
        </p>
        <label class="scd__label" for="scd-password">비밀번호</label>
        <input
          id="scd-password"
          ref="inputEl"
          v-model="password"
          class="scd__input"
          type="password"
          inputmode="numeric"
          autocomplete="current-password"
          :disabled="busy"
        />
        <p v-if="error" class="scd__error" role="alert">{{ error }}</p>
        <footer class="scd__foot">
          <button type="button" class="scd__btn scd__btn--ghost" :disabled="busy" @click="emit('close')">
            닫기
          </button>
          <button type="submit" class="scd__btn scd__btn--danger" :disabled="busy || !password.trim()">
            {{ busy ? '삭제 중…' : '삭제' }}
          </button>
        </footer>
      </form>
    </div>
  </div>
</template>

<script setup lang="ts">
import { nextTick, ref, watch } from 'vue'
import AppIcon from '@/components/common/AppIcon.vue'

const props = defineProps<{
  open: boolean
  orgName: string
  busy: boolean
  error: string
}>()

const emit = defineEmits<{
  close: []
  confirm: [password: string]
}>()

const password = ref('')
const inputEl = ref<HTMLInputElement | null>(null)

watch(
  () => props.open,
  (open) => {
    if (!open) {
      password.value = ''
      return
    }
    nextTick(() => inputEl.value?.focus())
  },
)

function onSubmit() {
  if (props.busy || !password.value.trim()) return
  emit('confirm', password.value.trim())
}
</script>

<style lang="scss" src="./ContractDeleteModal.scss"></style>
